<section class="block-case section-outset-y">
  <div class="container d-flex flex-column">
    <span class="subtitle subtitle-label mb-2" *ngIf="block.subtitle">{{ block.subtitle }}</span>

    <h1
      *ngIf="block.title"
      class="mb-6 text-max-width-sm h3 splitting splitting--word-in"
      [innerHTML]="block.title | highlight : 'font-display text-primary-gradient'"
      data-split
    ></h1>

    <ul class="row case-list">
      <li
        *ngFor="let case of block.cases; let i = index; trackBy: trackByFn"
        class="case-list__item col-12 col-md-6"
        [style.--list-index]="i"
        [style.--step-direction]="i % 2"
      >
        <article class="case-item" [class.set--link]="case.button">
          <fstr-image
            class="case-item__image anim--throw-image step-delay--3 has--skew-bg mb-4"
            [class.skew-bg--secondary]="i % 3 !== 0"
            [width]="1200"
            [height]="935"
            [alt]="case.image?.alt || case.title || 'case-image'"
            [imageSizes]="[300, 600, 800, 1200]"
            *ngIf="case.image"
            [image]="case.image"
          ></fstr-image>
          <h1 class="text-max-width-xs mb-0 mb-4 fw-normal h5" *ngIf="case.title">{{ case.title | truncate : 100 }}</h1>
          <span *ngIf="case.subtitle">{{ case.subtitle }}</span>
          <a *ngIf="case.button" class="case-item__button anim--throw-image step-delay--3" [routerLink]="case.button.routerLink">
            <span class="show-case-button">{{ 'bekijk-case-knoptekst' | fromDictionary }}</span>
          </a>
        </article>
      </li>
    </ul>
    <a [routerLink]="block.button.routerLink" class="align-self-end button button--secondary button-chip" *ngIf="block.button">
      <span>{{ block.button.text || ('meer-cases-knoptekst' | fromDictionary) }}</span>
      <fstr-icon anchor="icon-arrow-right"></fstr-icon>
    </a>
  </div>
</section>
